import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CompanyService } from 'src/app/setting/services/company.service';

@Component({
    selector: 'app-shift-settings',
    templateUrl: './shift-settings.component.html',
    styleUrls: ['./shift-settings.component.css']
})
export class ShiftSettingsComponent implements OnInit {
    @Input() public settings: any;

    public form: UntypedFormGroup;
    public submitted = false;
    public rangeOptions = [
        {value: 'WEEK', label: this._translateService.instant('settings.range_WEEK')},
        {value: 'TWO_WEEKS', label: this._translateService.instant('settings.range_TWO_WEEKS')},
        {value: 'WEEK_FULL', label: this._translateService.instant('settings.range_WEEK_FULL')},
        {value: 'TWO_WEEKS_FULL', label: this._translateService.instant('settings.range_TWO_WEEKS_FULL')},
    ];

    public constructor(
        private _companyService: CompanyService,
        private _fb: UntypedFormBuilder,
        private _translateService: TranslateService
    ) { }

    public get f(): { [formControlName: string]: AbstractControl; } {
        return this.form.controls;
    }

    public ngOnInit(): void {
        this.form = this._fb.group({
            'company.attendance.shifts_range': ['WEEK'],
            'company.attendance.shifts_show_not_approved': [false],
        });

        this.form.patchValue({
            'company.attendance.shifts_range': this.settings.company_settings.attendance?.shifts_range || 'WEEK',
            'company.attendance.shifts_show_not_approved': this.settings.company_settings.attendance?.shifts_show_not_approved || false,
        });
    }

    public onSubmit(): void {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        const value = this.form.value;

        value.settings_type = 'attendance';

        void this._companyService.saveCompanySetting(this.form.value);
    }
}
